import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(({ breakpoints, spacing }) => ({
  productContainer: {
    margin: "2% 0",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    alignItems: "center",
    justifyItems: "center",
    position: "relative",
  },
  productImg: {
    width: "80%",
    maxHeight: "625px",
    borderRadius: "5px",
  },
  details: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  code: {
    display: "flex",
    alignItems: "center",
  },
  features: {
    display: "grid",
    gridTemplateColumns: "repeat(5, 69px)",
    gridTemplateRows: "40px auto",
    gap: spacing(2),
    position: "relative",
  },
  productName: {
    fontWeight: "bold",
    fontSize: "64px",
    lineHeight: "100%",
    margin: "10px 0",
  },
  specs: {
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "20px",
    margin: "5px 0",
  },
  specsValues: {
    fontWeight: 300,
    fontSize: "12px",
    lineHeight: "15px",
    margin: "5px 0",
  },
  specsValuesCode: {
    fontWeight: 300,
    fontSize: "12px",
    lineHeight: "15px",
    margin: "0 10px",
  },
  btn0: {
    height: "20px",
    width: "20px",
    backgroundColor: " rgb(5, 185, 32)",
    border: "none",
    borderRadius: "50%",
    border: "1px solid rgba(0, 0, 0, 0.411)",
    marginBottom: "4px",
  },
  btn1: {
    height: "20px",
    width: "20px",
    backgroundColor: " yellow",
    border: "none",
    borderRadius: "50%",
    border: "1px solid rgba(0, 0, 0, 0.411)",
    marginBottom: "4px",
  },
  btn2: {
    height: "20px",
    width: "20px",
    backgroundColor: " white",
    border: "none",
    borderRadius: "50%",
    border: "1px solid rgba(0, 0, 0, 0.411)",
    marginBottom: "4px",
  },
  btn3: {
    height: "20px",
    width: "20px",
    backgroundColor: " red",
    border: "none",
    borderRadius: "50%",
    border: "1px solid rgba(0, 0, 0, 0.411)",
    marginBottom: "4px",
  },
  btnCont: {
    width: "120px",
    justifyContent: "space-around",
    display: "flex",
    flexDirection: "row",
    position: "absolute",
    bottom: "0%",
    right: " 25%",
  },
}));

export default useStyles;
